import React from 'react'
import { arrayMove, SortableContainer, SortableElement } from 'react-sortable-hoc'
import { DragDropContainer, DropTarget } from 'react-drag-drop-container'
import * as ReactDOM from 'react-dom'
import { withStyles } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { scrollToTop } from './ArticlePointMapSegment'
import pyramidImage from 'media/pyramid_of_hate/pyramid.png'

export const DRAG_NAMES = 'DRAG_NAMES'

const styles = theme => ({
  pointsBackground: {
    margin: '0 auto',
    flex: 1
  },
  pyramidContainer: {
    marginBottom: 200,

  },
  pyramidImage: {
    display: 'flex',
    padding: '60px 0px',
    position: 'relative'
  },
  pyramidSvgContainer: {
    height: 128,
    margin: 10,
    fontSize: 22,
    backgroundColor: '#d0d0d0',
    // width: '100%',
    color: 'black',
    textTransform: 'uppercase',
    // display: 'flex',
    alignItems: 'center',

  },
  sortableList: {},

  sortableItem: {
    margin: '10px',
    textAlign: 'justify',
    paddingLeft: 5,
    borderLeft: 'black solid',
    minHeight: 160
  },
  SortableItemHeader: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    // margin: 5,
    padding: '3px 5px',
    textTransform: 'uppercase'
  },
  svg: {
    width: '100%',
    display: 'block',
    backgroundColor: '#EDEDED',
  },
  polygon: {
    fill: theme.palette.common.white,
    // fill: 'grey',
    stroke: theme.palette.divider,
    strokeWidth: 1,
  },
  svgText: {
    backgroundColor: theme.palette.primary.main,
    color: 'white'
  },
  pyramidHeader: {
    backgroundColor: '#d0d0d0',
    color: 'black',
    display: 'block',
    position: 'relative',
    padding: 5,
    width: '100%',
    textAlign: 'center'
  },
  wordSoup: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    backgroundColor: '#520007',
    padding: '70px 20px',
    color: 'white'
    // width: '50%'
  },
  draggableText: {
    margin: 3
  },
  dropTarget: {
    // backgroundColor: 'green',
    position: 'relative',
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '100%',
    height: '100%',
    top: -30,
  },
  dragButton: {
    backgroundColor: '#ac0000',
    fontSize: 12,
    textDecoration: 'unset',

    color: '#fff7f7',
    margin: 1,
    padding: 10,
    borderRadius: 0

  },
  pyramidButton: {
    fontSize: 9,
    backgroundColor: '#ac0000',
    color: 'white',
    margin: 1,
    padding: 10,
    borderRadius: 0
  },
  instructionHeader: {
    padding: 15
  },
  showMore: {
    fontSize: 16,
    color: 'white',
    backgroundColor: '#d80000',
    height: 33,
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    right: 35,
    padding: 5,
    borderRadius: 0

  },
  dragDescription: {
    backgroundColor: '#8b0000',
    color: '#fff7f7',
    fontSize: 26,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    padding: 20,
  },
  dragDescriptionBar: {
    backgroundColor: '#520007',
    color: 'white',
    fontSize: 23,
    fontWeight: 'bold',
  },
  sortablePyramid: {
    userSelect: 'none',
    width: '33%',
    marginRight: 20
  },
  storyHeader: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    margin: '10px 0',
    padding: 15
  },
  storyContent: {
    fontSize: 16
  },
  dragLevel: {
    backgroundColor: '#520007'
  },
  pyramidSideImage: {
    position: 'absolute',
    left: -110,
    top: 0,

  },
  pyramidSideImage2: {
    position: 'absolute',
    left: -110,
    top: 0,

  },
  pyramidSideContainer: {
    width: '33%',
    margin: '0px 0px 0px 8%',

  },
  pyramidSideContainerRow: {
    backgroundColor: '#520007',
    color: 'white',
    fontSize: 16,
    textAlign: 'left',
    fontWeight: 'bold',
    paddingLeft: '55%',
    height: 80,
    margin: 10,
    display: 'flex',
    alignItems: 'center',
    textTransform: 'uppercase',
    alignText: 'start'

  },
  sortablePyramidItem: {
    textAlign: 'left',
    height: 80,
    margin: 10,
    fontWeight: 'bold',
    color: 'white',
    fontSize: 15,
    backgroundColor: '#520007',
    alignItems: 'center',
    display: 'flex',
    alignText: 'start',
    zIndex: 1500,
    padding: 10,
    paddingRight: 130,
    position: 'relative'
  },
  pyramidChoices: {
    backgroundColor: '#e5e5e5',
    width: '33%',
    maxWidth: 630,
    padding: 20,
    border: 'solid 1px #707070',
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)'

  },
})

let pyramid = {
  levels: [
    {
      order: 5,

      pyramidHeader: 'Prejudiced attitudes',
      storyHeader: 'Immigrants are taking the jobs from locals.',
      storyContent: 'The wave of resentment is sweeping through the country aimed at foreign nationals. The unrest began earlier this month, spreading to at least nine provinces, and reaching the capital at the end of the month. At least six people have been killed, and thousands driven from their homes. It’s because of a perception that immigrants are taking the jobs from locals. The president is calling for calm, saying violence against foreigners is unacceptable.',
      dragItems: [
        'Stereotyping',
        'Fear of differences',
        'Insensitive remarks',
        'Justifying biases by seeking out like-minded people',
        'Microaggression',
        'Non-inclusive language ',
        'Screening out positive information',
        'Accepting negative information of misinformation',
      ]
    },
    {
      order: 4,
      pyramidHeader: 'Acts of prejudice',
      storyHeader: 'Helping schemes - not for everyone.',
      storyContent: 'On one of my field visits to those villages, I met an old woman, asking me for help. She told me that she was a widow with no children. She didn’t have any work and she didn’t have anyone to depend on. She went from house to house in the village asking for food and somehow managed to live on what she got from them. She said, “I have heard that there are many schemes through which I could get some money. I have visited all government offices, but no one is processing anything for me. Maybe they are treating me this way because I am a woman. Or maybe it is because I belong to a low caste and they think I have no power over them. Could you please help me?”'
      ,
      dragItems: [
        'Biased/belittling jokes',
        'Bullying',
        'Dehumanization',
        'Name-calling',
        'Ridicule',
        'Slurs/epithets',
        'Social avoidance',
      ]
    },
    {
      order: 3,
      pyramidHeader: 'Discrimination',
      storyHeader: 'Accommodation struggle',
      storyContent: 'Renters are hostage to homeowners. “My husband wanted to transfer to the city but couldn’t because of the accommodation problem. If you want to rent, you must pay a lot of money.” R. said. “We were asked to pay at least three months of rent in advance because we are Asian. Otherwise, the house cannot be rented although in the advertisement, only one month rent in advance was requested. Even though we were willing to pay the security deposit, at the last moment some homeowners rejected us because of a trust issue. They said Asians were not reliable although we were about to sign the lease.” K., a Nigerian student at the University added that she tried looking for flats but couldn’t find one with her budget. “If I find any, when I go see the flat, homeowners attitude shows unwillingness to rent to Nigerian”.',
      dragItems: [
        'Criminal justice disparities',
        'Economic discrimination',
        'Educational discrimination',
        'Employment discrimination',
        'Housing discrimination & segregation',
        'Political discrimination'
      ]
    },
    {
      order: 2,
      pyramidHeader: 'Violence',
      storyHeader: 'Homosexuals threatened',
      storyContent: 'The country\'s authorities are confiscating and searching the phones of men they suspect of being gay and pressuring them to take anal tests and to confess to homosexual activity, Human Rights Watch said today. Prosecutors then use information collected in this fashion to prosecute them for homosexual acts between consenting partners, under the country’s harsh sodomy laws. Individuals are being threatened by phone calls, stopped on the streets, humiliated and sometimes tortured by police.',
      dragItems: [
        'Arson',
        'Assault',
        'Desecration',
        'Murder',
        'Rape',
        'Terrorism',
        'Threats',
        'Vandalism',
      ]
    },
    {
      order: 1,
      pyramidHeader: 'Genocide',
      storyHeader: 'Thousands of people died',
      storyContent: 'Thousands of people have died and more than 700,000 members of the community have fled to neighbouring countries. There have also been widespread allegations of human rights abuses, including arbitrary killing, rape and burning of land systematically over many years.',
      dragItems: [
        'Causing serious bodily or mental harm',
        'Deliberate annihilation of an entire people',
        'Forcibly transferring children',
        'Imposing measures intended to prevent births',
        'Deliberately inflicting conditions of life calculated to bring about the group’s physical destruction.', // in whole or in part',
        'Killing members of the group',
      ]
    }
  ]
}

export function shuffleArray (array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]
  }
}

export function dynamicSort (property, property2 = null) {
  let sortOrder = 1

  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }

  return function (a, b) {
    let a_v = a[property]
    let b_v = b[property]
    if (property2) {
      a_v = a_v[property2]
      b_v = b_v[property2]
    }
    if (typeof a_v === 'string') {
      if (sortOrder === -1) {
        return b_v.localeCompare(a_v)
      } else {
        return a_v.localeCompare(b_v)
      }
    } else {
      if (a_v < b_v) {
        return -1 * sortOrder
      } else if (a_v > b_v) {
        return sortOrder
      } else {
        return 0
      }
    }
  }
}

function sortIntoPairs (arr) {
  let ret = []
  arr = arr.slice()
  let lineWidth = 80
  let lastsLine = 0
  let element
  let i
  while (arr.length > 0) {
    if (lastsLine < lineWidth) {
      for (i = arr.length - 1; i >= 0; i--) {
        if ((arr[i].text.length + lastsLine < lineWidth) || arr[i].text.length >= lineWidth) {
          element = arr.splice(i, 1)[0]
          ret.push(element)
          lastsLine += element.text.length
          break

        }
      }
      if (i < 0 || lastsLine >= lineWidth) {
        lastsLine = 0
      }
    }
    if (lastsLine >= lineWidth) {
      lastsLine = 0
    }
    console.log(arr, ret)
  }
  return ret
}

const SortableItem = (SortableElement(({ value, classes, correct, itemOnClick }) =>
  <Typography variant="h1" className={classes.sortablePyramidItem} onClick={
    itemOnClick(value)
  }>
    {value.storyHeader}
    <br/>
    {/*to do change to button */}
    <Button className={classes.showMore} onClick={
      itemOnClick(value)
    }>MORE</Button>
  </Typography>
))

const SortableList = SortableContainer(({ items, classes, correct, itemOnClick }) => {
  return (
    <div className={classes.sortablePyramid}>
      {items.map((value, index) => (
        <SortableItem key={`item-${index}`} index={index} value={value}
                      itemOnClick={itemOnClick}
                      classes={classes} disabled={correct} correct={correct}/>
      ))}
    </div>
  )
})

function pointsFromOrder (order, width, height, lenght) {
  let points = []
  let w = width / lenght / 2.0
  let h = height / lenght

  points[0] = { x: width / 2 - w * order, y: h }
  points[1] = { x: width / 2 - w * (order - 1), y: 0 }
  points[2] = { x: width / 2 + w * (order - 1), y: 0 }
  points[3] = { x: width / 2 + w * order, y: h }

  return points.map(item => `${item.x},${item.y}`).join(' ')

}

class PyramidOfHateSegment extends React.Component {
  state = {
    items: pyramid.levels,
    correct: false,
    itemsToDrag: [],
    itemContainers: [],
    chosenStory: null
  }
  onSortEnd = ({ oldIndex, newIndex }) => {
    let newList = arrayMove(this.state.items, oldIndex, newIndex)
    let correct = true
    for (let i = 0; i < newList.length - 1; i++) {
      correct = correct && newList[i].order < newList[i + 1].order
    }

    this.setState({
      items: newList, correct
    })

  }

  // onMoveEnd (newList: Array<Object>, movedItem: Object, oldIndex: number, newIndex: number) {
  onMoveEnd (newList, movedItem, oldIndex, newIndex) {

  }

  componentDidMount () {
    let rect = ReactDOM.findDOMNode(this)
      .getBoundingClientRect()
    setTimeout(() => scrollToTop(this), 500)
    if (!this.boundingRect) {
      this.boundingRect = rect
      this.forceUpdate()
    } else {
      this.boundingRect = rect
    }
    this.resetDraggable()
    window.addEventListener('resize', this.updateSize(this))
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateFunction)
  }

  resetDraggable () {
    let itemsToDrag = []
    let itemContainers = []
    let level
    let key = 0
    for (let i = 0; i < pyramid.levels.length; i++) {
      level = pyramid.levels[i]
      // real items
      for (let dragItem of level.dragItems) {
        itemsToDrag.push({ order: level.order, text: dragItem, key: key++ })
      }

      itemContainers[level.order] = []

    }
    shuffleArray(itemsToDrag)
    this.setState({ itemsToDrag, itemContainers })
    this.setState({ chosenStory: this.state.itemsToDrag[0] })
  }

  updateSize (that) {
    that.updateFunction =
      () => {
        that.componentDidUpdate()
        that.forceUpdate()
      }
    return that.updateFunction
  }

  componentDidUpdate (prevProps, prevState, snapshot) {

    let rect = ReactDOM.findDOMNode(this)
      .getBoundingClientRect()
    this.boundingRect = rect
  }

  render () {
    let {
      classes,
      // ...props
    } = this.props
    let { correct, itemContainers, itemsToDrag, chosenStory } = this.state

    let sortedPyramid = pyramid.levels.slice().sort(dynamicSort('order'))
    let pyramidHeight = this.boundingRect ? this.boundingRect.height : 0
    // if (pyramidHeight > 800) {
    //   pyramidHeight = 800
    // }
    let pyramidWidth = this.boundingRect ? this.boundingRect.width / 2 : 0
    let segmentHeight = pyramidHeight / sortedPyramid.length

    return <div>
      <Typography variant='h2' className={classes.dragDescription}>
        DRAG DESCRIPTIONS ON THE RIGHT, SO THEY FIT THE TITLES
      </Typography>
      {/*Pyramid of HATE {correct ? 'yes' : 'no'}*/}
      <div className={classes.pyramidContainer}>
        <div className={classes.pyramidImage}>
          <img src={pyramidImage} alt="pyramid" className={classes.pyramidSideImage}/>
          <div className={classes.pyramidSideContainer}>
            {sortedPyramid.map((item, index) => (
              <div className={classes.pyramidSideContainerRow} key={index}>
                {item.pyramidHeader}
              </div>
            ))
            }
          </div>
          <SortableList items={this.state.items} onSortEnd={this.onSortEnd}
                        className={classes.sortablePyramid}
                        itemOnClick={(story) => () => {
                          console.log(story)
                          this.setState({ chosenStory: story })
                        }}
                        lockAxis='y'
                        distance={5}
            //             pressDelay={100}
                        classes={classes} correct={this.state.correct}/>

          <div className={classes.pyramidChoices}>
            {chosenStory ? <div>
              <Typography variant={'h1'} className={classes.storyHeader}>
                {chosenStory.storyHeader}
              </Typography>
              <Typography className={classes.storyContent}>
                {chosenStory.storyContent}
              </Typography>
            </div> : ''}
          </div>

        </div>
      </div>
      <div>
        <div>
          <div className={classes.wordSoup}>
            <Typography variant={'h1'} className={classes.instructionHeader}>
              Drag the action to the correct level of the pyramid
            </Typography>
            {itemsToDrag.map(item => (
                <DragDropContainer
                  targetKey={`target_${item.order}`} key={item.key}
                  className={classes.draggableText}
                  dragData={item}
                  style={{ position: 'unset', flex: 1 }}
                >
                  <Button className={classes.dragButton}>{`${item.text}`}</Button>
                </DragDropContainer>
              )
            )
            }
          </div>
          {/*<img src={pyramidImage} alt="pyramid" className={classes.pyramidSideImage2}/>*/}
          {sortedPyramid.map((item, index) => (
            <div className={classes.pyramidSvgContainer} key={item.order}
            >

              <span className={classes.pyramidHeader}> {item.pyramidHeader}</span>
              <DropTarget targetKey={`target_${item.order}`}
                          style={{ height: 128, width: '100%' }}
                          onHit={({ dragData, dragElem, containerElem, }) => {
                            console.log(dragData)
                            itemsToDrag.splice(
                              itemsToDrag.indexOf(dragData), 1
                            )
                            itemContainers[dragData.order].push(dragData)
                            this.setState({ itemsToDrag, itemContainers })

                          }}
              >
                <div className={classes.dropTarget}
                >
                  {sortIntoPairs(
                    (itemContainers[item.order] || []).sort(
                      dynamicSort('text', 'length')
                    )
                  ).map(dragItem => (
                    <Button className={classes.pyramidButton} key={dragItem.key}>{`${dragItem.text}`}</Button>
                  ))}
                  &nbsp;
                </div>
              </DropTarget>
            </div>
          ))}
        </div>

      </div>

    </div>
  }
}

export default withStyles(styles)(PyramidOfHateSegment)
